import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./header.module.scss";
import ConfirmationModal from "../confirmationModal";
import { useState } from "react";
import { deleteExternalContractById } from "../../../../setup/api/services/contract";
import { ReactComponent as DeleteResource } from "../../../../assets/images/svg/deleteResource.svg";

interface IHeaderProps {
  isDirty: boolean;
  createdId: string;
}

const Header = ({ isDirty, createdId }: IHeaderProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { complexId, milestoneId } = useParams();
  const isCreateComplex = !complexId && !milestoneId;
  const isAddNewMilestone = !!complexId && !milestoneId;

  const [modalOpen, setModalOpen] = useState(false);
  return (
    <div>
      <div className={styles.headerRow}>
        {isCreateComplex && (
          <h3 className={styles.title}>{t("lbl_create_new_project")}</h3>
        )}
        <p
          onClick={() => {
            if (isDirty) setModalOpen(true);
            else navigate(-1);
          }}
          className={styles.cancel}>
          {t("lbl_cancel")}
        </p>
      </div>
      <div className={styles.divider} />
      <ConfirmationModal
        handleClose={() => setModalOpen(false)}
        horizontalButtons
        handleConfirm={async () => {
          setModalOpen(false);
          if (createdId) {
            if (isCreateComplex) await deleteExternalContractById(createdId);
            else if (isAddNewMilestone)
              await deleteExternalContractById(createdId);
          }

          navigate(-1);
        }}
        modalOpen={modalOpen}
        title={
          isCreateComplex || isAddNewMilestone
            ? t("lbl_confirm_cancel_create_complex")
            : t("lbl_confirm_cancel_edit_complex")
        }
        description={t("lbl_discarded_changes_gone")}
        icon={<DeleteResource />}
        confirmText={t("lbl_cancel")}
        cancelText={t("lbl_delete_transaction_back_btn")}
        containerStyle={styles.modalContainer}
      />
    </div>
  );
};

export default Header;
